import { atom } from 'jotai';

interface ILegalPageTraffic {
  canonicalUrl: string;
}

export const $LegalPageLevelTraffic = atom({} as ILegalPageTraffic);
$LegalPageLevelTraffic.debugLabel = '$LegalPageLevelTraffic';
